module.exports = __webpack_public_path__ + "static/media/dragon.a3d1eb01.mp4";